import { render, staticRenderFns } from "./BaseReload.vue?vue&type=template&id=354817f4&"
import script from "./BaseReload.vue?vue&type=script&lang=js&"
export * from "./BaseReload.vue?vue&type=script&lang=js&"
import style0 from "./BaseReload.vue?vue&type=style&index=0&id=354817f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports